import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
import { getIncoming } from '../lib/api';

export function IncomingSection() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    getIncoming().then(setItems).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="mt-20" data-testid="incoming-section">
      <div className="text-center mb-10">
        <p className="text-alp-gold text-xs tracking-[0.3em] uppercase mb-3">Arriving Soon</p>
        <h2 className="font-serif text-4xl md:text-5xl text-alp-cream">Incoming Stock</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((item) => (
          <div key={item.id} data-testid={`incoming-card-${item.id}`} className="border border-alp-line rounded-lg overflow-hidden bg-alp-card/40 flex flex-col">
            {item.image ? (
              <div className="aspect-[16/9] overflow-hidden bg-alp-dark">
                <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
              </div>
            ) : null}
            <div className="p-6 flex flex-col flex-1">
              <h3 className="font-serif text-2xl text-alp-cream mb-2">{item.name}</h3>
              {item.note ? <p className="text-alp-gray text-sm leading-relaxed flex-1">{item.note}</p> : null}
              {item.eta ? (
                <div className="inline-flex items-center gap-2 mt-4 text-xs tracking-[0.12em] uppercase text-alp-gold">
                  <Clock size={14} /> ETA: {item.eta}
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default IncomingSection;
